// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__208lt","name":"Header_name__1Ljh4","birthday":"Header_birthday__1Z7d-","skeleton":"Header_skeleton__2YL0U"};